<template>
    <section class="portfolio section" id="portfolio">
        <h2 class="section__title">Portfolio</h2>
        <span class="section__subtitle">Most recent work</span>

        <div class="portofolio__container container swiper">
            <div class="swiper-wrapper">
                <!--==================== PORTFOLIO ITEMS ====================-->
                <div v-for="item in portfolioItems" :key="item.id" class="portofolio__content grid swiper-slide">
                    <img :src="item.image" alt="" class="portofolio__img">

                    <div class="portofolio__data">
                        <h3 class="portofolio__title">{{ item.title }}</h3>
                        <p class="portofolio__description">{{ item.description }}</p>
                        <a v-if="item.demoLink" :href="item.demoLink" class="button button--flex button--small portofolio__button" style="padding: 0.7rem 0.7rem;">
                            Demo
                            <i class="uil uil-arrow-right button__icon"></i>
                        </a>
                    </div>
                </div>
            </div>
            
            <!-- add arrows -->
            <div class="swiper-button-next">
                <i class="uil uil-angle-right-b swiper-portofolio-icon"></i>
            </div>
            <div class="swiper-button-prev">
                <i class="uil uil-angle-left-b swiper-portofolio-icon"></i>
            </div>

            <!-- add pagination -->
            <div class="swiper-pagination"></div>
        </div>
    </section>
</template>

<script>
import { portfolioData } from '@/data/portfolio.js';

export default {
    name: 'Portfolio',
    data() {
        return {
            portfolioItems: portfolioData
        };
    }
}
</script>
